import React from "react";
import "./footer.css";
function Footer() {
  return <div className="footer">Made By Nikhil Gupta</div>;
}

export default Footer;
